import React, { useMemo } from 'react'
import { IconButton } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { pipe, propEq, reject, slice } from 'ramda'
import { ClassesControlsEl, ClassesEl } from '../elements'
import ArtistInfoStore from '../stores/artist-info-store'
import { Link, useLocation } from 'react-router-dom'
import dimensions from '../../../Helpers/dimensions'
import Carousel from '../../carousel-v2'
import Button from '../../Buttons/Button'
import UpcomingClass from '../../cards-v2/course/upcoming'

const Classes = () => {
  const { pathname } = useLocation()
  const { livdemyId, classes } = ArtistInfoStore.useContainer()
  // const { trackEvent } = MixpanelTrackingStore.useContainer()

  const filteredClasses = useMemo(
    () => pipe(reject(propEq('url', pathname)), slice(0, 6))(classes),
    [classes, pathname],
  )

  return (
    <ClassesEl>
      <Carousel
        data={filteredClasses}
        itemWidth={dimensions.rem(15)}
        item={(itemData, params) => (
          <UpcomingClass data={itemData} params={params} />
        )}
        controls={(inFocus, next, prev) => (
          <ClassesControlsEl>
            <div className='controls'>
              <IconButton onClick={() => prev()} disabled={inFocus === 0}>
                <ArrowForwardIosIcon />
              </IconButton>
              <IconButton
                onClick={() => next()}
                disabled={inFocus === classes.length - 1}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </div>
            <Link to={`/${livdemyId}`}>
              <Button
                theme='primary'
                onClick={() => {
                  // trackEvent(`artist-details-view-more`, {
                  //   id: data?.id,
                  //   name: data?.name,
                  //   from: asPath,
                  // })
                }}
              >
                View More
              </Button>
            </Link>
          </ClassesControlsEl>
        )}
      />
    </ClassesEl>
  )
}

export default Classes
